import {Component, ElementRef, Injectable, ViewChild, AfterViewInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';

export interface RefPromptOptions {
    title: string;
    text: string;
    label: string;
    okText: string;
    /** Returns an error message, or '' when the value is valid. */
    check?: (v: string) => string;
}

/** Confirmation modal that asks for a reason or transaction ID. */
@Component({
    selector: 'app-ref-prompt',
    template: `
        <div class="ref-app ref-prompt">
            <h3>{{o.title}}</h3>
            <p class="ref-muted">{{o.text}}</p>
            <label for="refPromptInput">{{o.label}}</label>
            <textarea class="form-control" id="refPromptInput" #input rows="3" [(ngModel)]="value"></textarea>
            <div class="ref-err" aria-live="polite">{{error}}</div>
            <div class="ref-acts">
                <button class="btn btn-outline-secondary" type="button" (click)="modal.dismiss()">Cancel</button>
                <button class="btn btn-primary" type="button" (click)="ok()">{{o.okText}}</button>
            </div>
        </div>`
})
export class RefPromptComponent implements AfterViewInit {
    o: RefPromptOptions;
    value = '';
    error = '';
    @ViewChild('input') input: ElementRef<HTMLTextAreaElement>;

    constructor(public modal: NgbActiveModal) {
    }

    ngAfterViewInit() {
        setTimeout(() => this.input.nativeElement.focus(), 50);
    }

    ok() {
        const v = this.value.trim();
        const check = this.o.check || (x => x ? '' : 'Enter a reason so the team and partner know why.');
        this.error = check(v);
        if (this.error) {
            this.input.nativeElement.focus();
            return;
        }
        this.modal.close(v);
    }
}

@Injectable({providedIn: 'root'})
export class RefPromptService {
    constructor(private modalService: NgbModal) {
    }

    /** Resolves with the entered value, or null if cancelled. */
    ask(o: RefPromptOptions): Promise<string | null> {
        const ref = this.modalService.open(RefPromptComponent, {centered: true});
        ref.componentInstance.o = o;
        return ref.result.then(v => v, () => null);
    }
}
